<!-- @format -->

<template>
  <b-card>
    <b-row style="display:flex;">
      <b-col xl="8" lg="12" md="12" class="d-flex justify-content-between flex-column">
        <div class="d-flex justify-content-start">
          <b-avatar :src="userData.avatar | filterSrc" :text="avatarText(userData.real_name)" size="104px" rounded />
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0" v-if="userData.firstname || userData.lastname">
                {{ userData.firstname }} {{ userData.lastname }}
              </h4>
              <h4 class="mb-0" v-else>
                {{ userData.real_name }}
              </h4>
              <span class="card-text">{{ userData.email }}</span>
            </div>
            <div class="d-flex flex-wrap">
              <b-button :to="{ name: 'apps-users-edit', params: userData }" variant="outline-primary"> Modify information </b-button>
              <b-button :to="{ path: '/pages/account-setting' }" variant="outline-warning" class="ml-1"> Change password </b-button>
            </div>
          </div>
        </div>

        <!-- <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar variant="light-primary" rounded>
              <feather-icon icon="DollarSignIcon" size="18" />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">23.3k</h5>
              <small>Monthly Sales</small>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-avatar variant="light-success" rounded>
              <feather-icon icon="TrendingUpIcon" size="18" />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">$99.87k</h5>
              <small>Annual Profit</small>
            </div>
          </div>
        </div> -->
      </b-col>

      <b-col xl="3" lg="12" md="12">
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon icon="UserIcon" class="mr-75" />
              <span class="font-weight-bold">Agent ID</span>
            </th>
            <td class="pb-50">
              {{ userData.id }}
            </td>
          </tr>
          <!-- <tr>
            <th class="pb-50">
              <feather-icon icon="CheckIcon" class="mr-75" />
              <span class="font-weight-bold">Agent name</span>
            </th>
            <td class="pb-50 text-capitalize" v-if="userData.firstname || userData.lastname">{{ userData.firstname }} -- {{ userData.lastname }}</td>
            <td v-else>
              {{ userData.real_name }} -- {{ userData.gender }}
            </td>
          </tr> -->
          <tr>
            <th class="pb-50">
              <feather-icon icon="UserIcon" class="mr-75" />
              <span class="font-weight-bold">Firstname</span>
            </th>
            <td class="pb-50 text-capitalize">{{ userData.firstname }}</td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="UserIcon" class="mr-75" />
              <span class="font-weight-bold">Lastname</span>
            </th>
            <td class="pb-50 text-capitalize">{{ userData.lastname }}</td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="FlagIcon" class="mr-75" />
              <span class="font-weight-bold">Country</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.country }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="FlagIcon" class="mr-75" />
              <span class="font-weight-bold">Phone number</span>
            </th>
            <td class="pb-50">
              {{ userData.mobile }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="MapPinIcon" class="mr-75" />
              <span class="font-weight-bold">address 1</span>
            </th>
            <td class="pb-50">
              {{ userData.address || 'No information yet ~~' }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="MapPinIcon" class="mr-75" />
              <span class="font-weight-bold">address 2</span>
            </th>
            <td class="pb-50">
              {{ userData.address2 || 'No information yet ~~' }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="MapPinIcon" class="mr-75" />
              <span class="font-weight-bold">State</span>
            </th>
            <td class="pb-50">
              {{ userData.state || 'No information yet ~~' }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="MapPinIcon" class="mr-75" />
              <span class="font-weight-bold">City</span>
            </th>
            <td class="pb-50">
              {{ userData.city || 'No information yet ~~' }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="MapPinIcon" class="mr-75" />
              <span class="font-weight-bold">Referral Agent ID</span>
            </th>
            <td class="pb-50">
              {{ userData.invite_code || 'No information yet ~~' }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol } from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
  },
  filters: {
    filterSrc(val) {
      const deleString = 'https://tmp.bxapi.sdbaizhi.com/'
      const reg = new RegExp(deleString, 'g')
      return process.env.VUE_APP_BASE_URL.replace('/backend', '/') + val.replace(reg, '')
    },
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
}
</script>

<style></style>
